<template lang="pug">
  v-dialog(v-model="show" persistent max-width="500px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown" )
    v-snackbar(v-model="showError" color="error")
      span {{ errorMessage }}
      v-btn(dark text @click="showError = false")
        v-icon fal fa-times
    v-form.fill-height(v-model="isValid" ref="form" @submit.prevent="onSaveNewTemplateClick" lazy-validation)
      v-card
        v-card-title.pl-2 {{ $t('sendEmailDialog.newTemplateLabel') }}
        v-row.ma-0
          v-col.pl-2(cols="12")
            v-text-field(:label="$t('sendEmailDialog.newTemplateNameLabel')" :rules="nameRules" outlined autofocus v-model="templateName")

        v-divider
        v-card-actions
          v-spacer
          v-btn.mr-2(right color="primary" text :disabled="isSaveInProgress" @click="onCloseButtonClick") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn.mr-2(right color="primary" :disabled="!isValid" :loading="isSaveInProgress" type="submit" ) {{ $t('sendEmailDialog.saveNewTemplate') }}


</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'
import i18n from "@/i18n";


@Component({})
export default class AddNewMessageTemplateDialog extends Vue {

  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({ type: Boolean, default: false }) readonly show!: boolean


  private showError: boolean = false
  private errorMessage: TranslateResult | null = null
  private isSaveInProgress: boolean = false
  private templateName: string = ''
  private nameRules:  Array<(v: string) => string | boolean> = [
      (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    ]
  private isValid: boolean = true



  onCloseButtonClick (): void {
    this.$emit('close')
  }

  onSaveNewTemplateClick (): void {
    this.isSaveInProgress = true
    this.$emit('templateName', this.templateName)
  }

  mounted () {
    this.isValid = false
  }
}

</script>

<style lang="stylus" scoped>
.card-body
  overflow auto
</style>